// extracted by mini-css-extract-plugin
export var skipAnimation = "_36-0";